/**
 * Socket id of this browser tab, readable from the API client without
 * subscribing React to the websocket. Cleared when the socket disconnects.
 */
let currentSocketId: string | undefined;

export const setCurrentSocketId = (socketId: string | undefined): void => {
  currentSocketId = socketId;
};

export const getCurrentSocketId = (): string | undefined => currentSocketId;
